import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup } from '@mui/material';
import ShareButton from '../components/action_buttons/ShareButton.jsx';
import PurchaseButton from '../components/action_buttons/PurchaseButton.jsx';
import PlayTrackButton from '../components/action_buttons/PlayTrackButton.jsx';

const TrackActionButtons = ({
  id,
  artistName,
  trackName,
  purchase_url,
  is_purchased,
  mix_type,
  size = 'large',
}) => {
  return (
    <ButtonGroup size={size}>
      <PlayTrackButton id={id} size={size} />
      {mix_type !== 'ID' && (
        <PurchaseButton
          id={id}
          purchase_url={purchase_url}
          is_purchased={is_purchased}
          mix_type={mix_type}
          artistName={artistName}
          trackName={trackName}
          size={size}
        />
      )}
      <ShareButton
        id={id}
        artistName={artistName}
        trackName={trackName}
        isTrack
        size={size}
      />
    </ButtonGroup>
  );
};

// Add prop-types validation
TrackActionButtons.propTypes = {
  id: PropTypes.string.isRequired,
  artistName: PropTypes.string.isRequired,
  trackName: PropTypes.string.isRequired,
  purchase_url: PropTypes.string,
  is_purchased: PropTypes.boolean,
  mix_type: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default TrackActionButtons;
